import errorpageTemplate from './errorpage.html';

var config = function ($stateProvider) {
    
    /* Create the logout state and assign the template and controller. */
    $stateProvider
		.state('errorpage', {
			url: '/error',
			template: errorpageTemplate,
			controller: 'errorpageController',
			controllerAs: 'errorpageController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/errorpage/errorpage.route.js